<template>
    <div ref="discussionListContainer" class="container mb-5">

        <div class="k-tabs">
            <ul class="k-tabs__list">
                <li class="k-tabs__item k-tabs__item--active">
                    <span class="k-tabs__link k-tabs__list--nohover"><slot v-slot:title></slot></span>
                </li>
            </ul>

            <div class="k-tabs__actions">
                <a :href="createDiscussionLink" class="k-tabs__actions-link">
                    <svg class="k-tabs__actions-icon k-tabs__actions-icon--before" role="img" width="15" height="15">
                        <use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use>
                    </svg>
                    Přidat příspěvek
                </a>
            </div>
        </div>

        <transition-group name="list-complete" tag="div" class="k-table">
            <div v-for="discussion in discussions.data" :key="discussion.id" class="k-table__row">
                <div class="k-table__cell">
                    <div class="k-table__cell-image">
                        <img :src="discussion.user.prev_url" alt="" height="67px">
                    </div>

                    <div class="mr-auto">
                        <a :href="discussion.url">
                            <strong class="k-strong d-block mb-2">{{ discussion.title }}</strong>
                        </a>
                        <div class="k-table__cell-meta ml-0">Vytvořený dne {{ discussion.created_at }}</div>
                    </div>
 </div>
                    <div class="k-table__cell k-table__cell--info">
                        <div class="k-table__cell-meta mx-0">
                            <strong class="k-strong d-block mb-2">{{ discussion.responses_count }}</strong>
                            <div class="">odpovědí</div>
                        </div>
                    </div>

                    <div class="k-table__cell k-table__cell--info">
                        <div class="k-table__cell-meta mx-0">
                            <strong class="k-strong d-block mb-2">{{ discussion.views_count }}</strong>
                            <div class="">zobrazení</div>
                        </div>
                    </div>

                    <div class="k-table__cell k-table__cell--last-post text-left">
                        <div class="k-table__cell-meta mx-0">
                            {{ discussion.latest_response_date }} od <a :href="discussion.latest_response_user.detail_url"><strong class="k-strong">{{ discussion.latest_response_user.name }}</strong></a>
                            <div class="mt-2">poslední příspěvek</div>
                        </div>
                    </div>


            </div>
            <div key="0" v-if="discussions.data && discussions.data.length === 0" class="k-table__cell p-2">
                Nebyly nalezeny žádné příspěvky.
            </div>
        </transition-group>

        <pagination class="mt-5" :data="discussions" @pagination-change-page="paginate" :limit="2"></pagination>

    </div>
</template>

<script>
    import Pagination from 'laravel-vue-pagination';

    export default {
        components: {
            'pagination': Pagination
        },

        props: {
            /**
             * Data url
             */
            url: {
                type: String,
                required: true
            },
            initialSearch: {
                type: String,
                default: ''
            }
        },

        data: function () {
            return {
                discussions: {},
                search: this.initialSearch
            };
        },

        computed: {
            createDiscussionLink: function() {
                return Links.createDiscussion;
            }
        },

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function(page = 1) {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url,
                        params: {
                            page: page,
                            search: this.search
                        }
                    });
                    if (result.status === 200 && result.data) {
                        this.discussions = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },
            /**
             * Paginate results
             *
             * @param page
             * @returns void
             */
            paginate: async function(page = 1) {
                await this.getData(page);
                if (this.$refs.discussionListContainer) {
                    setTimeout( () => {
                        this.$scrollTo(this.$refs.discussionListContainer, 500, {offset: -80});
                    }, 300);
                }
            }
        },

        created() {
            // listen for search input event
            window.events.$on('searchInputSubmitted', (search, preventScroll = false) => {
                this.search = search;
                if (preventScroll) {
                    this.getData(1);
                }
                else {
                    this.paginate(1);
                }
            });
        },

        mounted() {
            this.getData();
        }
    }
</script>

<style scoped>
    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
    }

    .list-complete-leave {
        transition: opacity .5s;
    }

    .list-complete-enter-to {
        transition: opacity 1.5s;
    }
</style>
